export interface TimezoneOption {
  value: string;
  label: string;
  short: string;
  aliases?: string[];
}

export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { value: "Etc/GMT+12", label: "(UTC-12:00) International Date Line West", short: "AoE" },
  {
    value: "Etc/GMT+11",
    label: "(UTC-11:00) Coordinated Universal Time-11",
    short: "SST",
    aliases: ["Pacific/Midway", "Pacific/Niue", "Pacific/Pago_Pago"],
  },
  { value: "America/Adak", label: "(UTC-10:00) Aleutian Islands", short: "HAST" },
  { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii", short: "HST" },
  { value: "Pacific/Marquesas", label: "(UTC-09:30) Marquesas Islands", short: "MART" },
  {
    value: "America/Anchorage",
    label: "(UTC-09:00) Alaska",
    short: "AKST",
    aliases: [
      "America/Juneau",
      "America/Metlakatla",
      "America/Nome",
      "America/Sitka",
      "America/Yakutat",
    ],
  },
  {
    value: "Etc/GMT+9",
    label: "(UTC-09:00) Coordinated Universal Time-09",
    short: "GMT-9",
    aliases: ["Pacific/Gambier"],
  },
  { value: "America/Tijuana", label: "(UTC-08:00) Baja California", short: "PST" },
  { value: "Etc/GMT+8", label: "(UTC-08:00) Coordinated Universal Time-08", short: "GMT-8" },
  {
    value: "America/Los_Angeles",
    label: "(UTC-08:00) Pacific Time (US & Canada)",
    short: "PST",
    aliases: ["America/Vancouver"],
  },
  {
    value: "America/Phoenix",
    label: "(UTC-07:00) Arizona",
    short: "MST",
    aliases: ["America/Hermosillo"],
  },
  {
    value: "America/Mazatlan",
    label: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    short: "MST",
    aliases: ["America/Chihuahua"],
  },
  {
    value: "America/Denver",
    label: "(UTC-07:00) Mountain Time (US & Canada)",
    short: "MST",
    aliases: [
      "America/Boise",
      "America/Cambridge_Bay",
      "America/Edmonton",
      "America/Inuvik",
      "America/Yellowknife",
      "America/Ojinaga",
    ],
  },
  {
    value: "America/Whitehorse",
    label: "(UTC-07:00) Yukon",
    short: "MST",
    aliases: ["America/Dawson", "America/Dawson_Creek", "America/Creston", "America/Fort_Nelson"],
  },
  {
    value: "America/Guatemala",
    label: "(UTC-06:00) Central America",
    short: "CST",
    aliases: [
      "America/Belize",
      "America/Costa_Rica",
      "America/El_Salvador",
      "America/Managua",
      "America/Tegucigalpa",
    ],
  },
  {
    value: "America/Chicago",
    label: "(UTC-06:00) Central Time (US & Canada)",
    short: "CST",
    aliases: [
      "America/Indiana/Knox",
      "America/Indiana/Tell_City",
      "America/Matamoros",
      "America/Menominee",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Rainy_River",
      "America/Rankin_Inlet",
      "America/Resolute",
      "America/Winnipeg",
    ],
  },
  { value: "Pacific/Easter", label: "(UTC-06:00) Easter Island", short: "EAST" },
  {
    value: "America/Mexico_City",
    label: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
    short: "CST",
    aliases: ["America/Bahia_Banderas", "America/Merida", "America/Monterrey"],
  },
  {
    value: "America/Regina",
    label: "(UTC-06:00) Saskatchewan",
    short: "CST",
    aliases: ["America/Swift_Current"],
  },
  {
    value: "America/Bogota",
    label: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
    short: "COT",
    aliases: ["America/Eirunepe", "America/Guayaquil", "America/Lima", "America/Rio_Branco"],
  },
  { value: "America/Cancun", label: "(UTC-05:00) Chetumal", short: "EST" },
  {
    value: "America/New_York",
    label: "(UTC-05:00) Eastern Time (US & Canada)",
    short: "EST",
    aliases: [
      "America/Detroit",
      "America/Iqaluit",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Montreal",
      "America/Nassau",
      "America/Nipigon",
      "America/Pangnirtung",
      "America/Thunder_Bay",
      "America/Toronto",
    ],
  },
  { value: "America/Port-au-Prince", label: "(UTC-05:00) Haiti", short: "EST" },
  { value: "America/Havana", label: "(UTC-05:00) Havana", short: "CST" },
  {
    value: "America/Indiana/Indianapolis",
    label: "(UTC-05:00) Indiana (East)",
    short: "EST",
    aliases: [
      "America/Indianapolis",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Atikokan",
      "America/Cayman",
      "America/Jamaica",
      "America/Panama",
    ],
  },
  { value: "America/Grand_Turk", label: "(UTC-05:00) Turks and Caicos", short: "EST" },
  { value: "America/Asuncion", label: "(UTC-04:00) Asuncion", short: "PYT" },
  {
    value: "America/Halifax",
    label: "(UTC-04:00) Atlantic Time (Canada)",
    short: "AST",
    aliases: [
      "America/Glace_Bay",
      "America/Goose_Bay",
      "America/Moncton",
      "Atlantic/Bermuda",
      "America/Thule",
    ],
  },
  { value: "America/Caracas", label: "(UTC-04:00) Caracas", short: "VET" },
  {
    value: "America/Cuiaba",
    label: "(UTC-04:00) Cuiaba",
    short: "AMT",
    aliases: ["America/Campo_Grande"],
  },
  {
    value: "America/La_Paz",
    label: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    short: "BOT",
    aliases: [
      "America/Boa_Vista",
      "America/Guyana",
      "America/Manaus",
      "America/Porto_Velho",
      "America/Anguilla",
      "America/Antigua",
      "America/Aruba",
      "America/Barbados",
      "America/Blanc-Sablon",
      "America/Curacao",
      "America/Dominica",
      "America/Grenada",
      "America/Guadeloupe",
      "America/Kralendijk",
      "America/Lower_Princes",
      "America/Marigot",
      "America/Martinique",
      "America/Montserrat",
      "America/Port_of_Spain",
      "America/Puerto_Rico",
      "America/Santo_Domingo",
      "America/St_Barthelemy",
      "America/St_Kitts",
      "America/St_Lucia",
      "America/St_Thomas",
      "America/St_Vincent",
      "America/Tortola",
    ],
  },
  {
    value: "America/Santiago",
    label: "(UTC-04:00) Santiago",
    short: "CLT",
    aliases: ["Antarctica/Palmer", "Atlantic/Stanley"],
  },
  { value: "America/St_Johns", label: "(UTC-03:30) Newfoundland", short: "NST" },
  { value: "America/Araguaina", label: "(UTC-03:00) Araguaina", short: "BRT" },
  {
    value: "America/Sao_Paulo",
    label: "(UTC-03:00) Brasilia",
    short: "BRT",
    aliases: [
      "America/Recife",
      "America/Maceio",
      "America/Belem",
      "America/Fortaleza",
      "America/Santarem",
    ],
  },
  {
    value: "America/Cayenne",
    label: "(UTC-03:00) Cayenne, Fortaleza",
    short: "GFT",
    aliases: ["America/Paramaribo"],
  },
  {
    value: "America/Argentina/Buenos_Aires",
    label: "(UTC-03:00) City of Buenos Aires",
    short: "ART",
    aliases: [
      "America/Buenos_Aires",
      "America/Argentina/Catamarca",
      "America/Argentina/Cordoba",
      "America/Argentina/Jujuy",
      "America/Argentina/La_Rioja",
      "America/Argentina/Mendoza",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia",
    ],
  },
  {
    value: "America/Godthab",
    label: "(UTC-03:00) Greenland",
    short: "WGT",
    aliases: ["America/Nuuk"],
  },
  { value: "America/Montevideo", label: "(UTC-03:00) Montevideo", short: "UYT" },
  { value: "America/Punta_Arenas", label: "(UTC-03:00) Punta Arenas", short: "CLST" },
  { value: "America/Miquelon", label: "(UTC-03:00) Saint Pierre and Miquelon", short: "PMST" },
  { value: "America/Bahia", label: "(UTC-03:00) Salvador", short: "BRT" },
  {
    value: "Etc/GMT+2",
    label: "(UTC-02:00) Coordinated Universal Time-02",
    short: "GMT-2",
    aliases: ["America/Noronha", "Atlantic/South_Georgia"],
  },
  {
    value: "Atlantic/Azores",
    label: "(UTC-01:00) Azores",
    short: "AZOT",
    aliases: ["America/Scoresbysund"],
  },
  { value: "Atlantic/Cape_Verde", label: "(UTC-01:00) Cabo Verde Is.", short: "CVT" },
  {
    value: "UTC",
    label: "(UTC) Coordinated Universal Time",
    short: "UTC",
    aliases: ["Etc/UTC", "Etc/GMT"],
  },
  {
    value: "Africa/Casablanca",
    label: "(UTC+00:00) Casablanca",
    short: "WET",
    aliases: ["Africa/El_Aaiun"],
  },
  {
    value: "Europe/London",
    label: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    short: "GMT",
    aliases: [
      "Europe/Dublin",
      "Europe/Lisbon",
      "Europe/Guernsey",
      "Europe/Isle_of_Man",
      "Europe/Jersey",
      "Atlantic/Canary",
      "Atlantic/Faroe",
      "Atlantic/Madeira",
    ],
  },
  {
    value: "Atlantic/Reykjavik",
    label: "(UTC+00:00) Monrovia, Reykjavik",
    short: "GMT",
    aliases: [
      "Africa/Abidjan",
      "Africa/Accra",
      "Africa/Bamako",
      "Africa/Banjul",
      "Africa/Bissau",
      "Africa/Conakry",
      "Africa/Dakar",
      "Africa/Freetown",
      "Africa/Lome",
      "Africa/Monrovia",
      "Africa/Nouakchott",
      "Africa/Ouagadougou",
      "Atlantic/St_Helena",
    ],
  },
  { value: "Africa/Sao_Tome", label: "(UTC+00:00) Sao Tome", short: "GMT" },
  {
    value: "Europe/Berlin",
    label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    short: "CET",
    aliases: [
      "Europe/Amsterdam",
      "Europe/Rome",
      "Europe/Stockholm",
      "Europe/Vienna",
      "Europe/Zurich",
      "Europe/Andorra",
      "Europe/Busingen",
      "Europe/Gibraltar",
      "Europe/Luxembourg",
      "Europe/Malta",
      "Europe/Monaco",
      "Europe/San_Marino",
      "Europe/Vaduz",
      "Europe/Vatican",
    ],
  },
  {
    value: "Europe/Budapest",
    label: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    short: "CET",
    aliases: [
      "Europe/Belgrade",
      "Europe/Bratislava",
      "Europe/Ljubljana",
      "Europe/Prague",
      "Europe/Podgorica",
      "Europe/Tirane",
    ],
  },
  {
    value: "Europe/Paris",
    label: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    short: "CET",
    aliases: ["Europe/Brussels", "Europe/Copenhagen", "Europe/Madrid", "Africa/Ceuta"],
  },
  {
    value: "Europe/Warsaw",
    label: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    short: "CET",
    aliases: ["Europe/Sarajevo", "Europe/Skopje", "Europe/Zagreb"],
  },
  {
    value: "Africa/Lagos",
    label: "(UTC+01:00) West Central Africa",
    short: "WAT",
    aliases: [
      "Africa/Algiers",
      "Africa/Bangui",
      "Africa/Brazzaville",
      "Africa/Douala",
      "Africa/Kinshasa",
      "Africa/Libreville",
      "Africa/Luanda",
      "Africa/Malabo",
      "Africa/Ndjamena",
      "Africa/Niamey",
      "Africa/Porto-Novo",
      "Africa/Tunis",
    ],
  },
  { value: "Asia/Amman", label: "(UTC+02:00) Amman", short: "EET" },
  {
    value: "Europe/Bucharest",
    label: "(UTC+02:00) Athens, Bucharest",
    short: "EET",
    aliases: ["Europe/Athens"],
  },
  { value: "Asia/Beirut", label: "(UTC+02:00) Beirut", short: "EET" },
  { value: "Africa/Cairo", label: "(UTC+02:00) Cairo", short: "EET" },
  {
    value: "Europe/Chisinau",
    label: "(UTC+02:00) Chisinau",
    short: "EET",
    aliases: ["Europe/Tiraspol"],
  },
  { value: "Asia/Damascus", label: "(UTC+02:00) Damascus", short: "EET" },
  { value: "Asia/Gaza", label: "(UTC+02:00) Gaza, Hebron", short: "EET", aliases: ["Asia/Hebron"] },
  {
    value: "Africa/Johannesburg",
    label: "(UTC+02:00) Harare, Pretoria",
    short: "SAST",
    aliases: [
      "Africa/Harare",
      "Africa/Maputo",
      "Africa/Lusaka",
      "Africa/Blantyre",
      "Africa/Bujumbura",
      "Africa/Gaborone",
      "Africa/Kigali",
      "Africa/Lubumbashi",
      "Africa/Maseru",
      "Africa/Mbabane",
    ],
  },
  {
    value: "Europe/Kyiv",
    label: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    short: "EET",
    aliases: [
      "Europe/Kiev",
      "Europe/Helsinki",
      "Europe/Riga",
      "Europe/Sofia",
      "Europe/Tallinn",
      "Europe/Vilnius",
      "Europe/Mariehamn",
      "Europe/Uzhgorod",
      "Europe/Zaporozhye",
    ],
  },
  { value: "Asia/Jerusalem", label: "(UTC+02:00) Jerusalem", short: "IST" },
  { value: "Africa/Juba", label: "(UTC+02:00) Juba", short: "CAT" },
  { value: "Europe/Kaliningrad", label: "(UTC+02:00) Kaliningrad", short: "EET" },
  { value: "Africa/Khartoum", label: "(UTC+02:00) Khartoum", short: "CAT" },
  { value: "Africa/Tripoli", label: "(UTC+02:00) Tripoli", short: "EET" },
  { value: "Africa/Windhoek", label: "(UTC+02:00) Windhoek", short: "CAT" },
  { value: "Asia/Baghdad", label: "(UTC+03:00) Baghdad", short: "AST" },
  { value: "Europe/Istanbul", label: "(UTC+03:00) Istanbul", short: "TRT" },
  {
    value: "Asia/Riyadh",
    label: "(UTC+03:00) Kuwait, Riyadh",
    short: "AST",
    aliases: ["Asia/Kuwait", "Asia/Aden", "Asia/Bahrain", "Asia/Qatar"],
  },
  { value: "Europe/Minsk", label: "(UTC+03:00) Minsk", short: "MSK" },
  {
    value: "Europe/Moscow",
    label: "(UTC+03:00) Moscow, St. Petersburg",
    short: "MSK",
    aliases: ["Europe/Kirov", "Europe/Simferopol"],
  },
  {
    value: "Africa/Nairobi",
    label: "(UTC+03:00) Nairobi",
    short: "EAT",
    aliases: [
      "Africa/Addis_Ababa",
      "Africa/Asmara",
      "Africa/Asmera",
      "Africa/Dar_es_Salaam",
      "Africa/Djibouti",
      "Africa/Kampala",
      "Africa/Mogadishu",
      "Indian/Antananarivo",
      "Indian/Comoro",
      "Indian/Mayotte",
    ],
  },
  { value: "Europe/Volgograd", label: "(UTC+03:00) Volgograd", short: "VOLT" },
  { value: "Asia/Tehran", label: "(UTC+03:30) Tehran", short: "IRST" },
  {
    value: "Asia/Dubai",
    label: "(UTC+04:00) Abu Dhabi, Muscat",
    short: "GST",
    aliases: ["Asia/Muscat"],
  },
  {
    value: "Europe/Astrakhan",
    label: "(UTC+04:00) Astrakhan, Ulyanovsk",
    short: "SAMT",
    aliases: ["Europe/Ulyanovsk"],
  },
  { value: "Asia/Baku", label: "(UTC+04:00) Baku", short: "AZT" },
  { value: "Europe/Samara", label: "(UTC+04:00) Izhevsk, Samara", short: "SAMT" },
  {
    value: "Indian/Mauritius",
    label: "(UTC+04:00) Port Louis",
    short: "MUT",
    aliases: ["Indian/Mahe", "Indian/Reunion"],
  },
  { value: "Europe/Saratov", label: "(UTC+04:00) Saratov", short: "MSK" },
  { value: "Asia/Tbilisi", label: "(UTC+04:00) Tbilisi", short: "GET" },
  { value: "Asia/Yerevan", label: "(UTC+04:00) Yerevan", short: "AMT" },
  { value: "Asia/Kabul", label: "(UTC+04:30) Kabul", short: "AFT" },
  {
    value: "Asia/Tashkent",
    label: "(UTC+05:00) Ashgabat, Tashkent",
    short: "UZT",
    aliases: [
      "Asia/Ashgabat",
      "Asia/Samarkand",
      "Asia/Aqtau",
      "Asia/Aqtobe",
      "Asia/Atyrau",
      "Asia/Dushanbe",
      "Asia/Oral",
    ],
  },
  { value: "Asia/Yekaterinburg", label: "(UTC+05:00) Ekaterinburg", short: "YEKT" },
  {
    value: "Asia/Karachi",
    label: "(UTC+05:00) Islamabad, Karachi",
    short: "PKT",
    aliases: ["Indian/Kerguelen", "Indian/Maldives"],
  },
  { value: "Asia/Qyzylorda", label: "(UTC+05:00) Qyzylorda", short: "QYZT" },
  {
    value: "Asia/Kolkata",
    label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    short: "IST",
    aliases: ["Asia/Calcutta"],
  },
  { value: "Asia/Colombo", label: "(UTC+05:30) Sri Jayawardenepura", short: "IST" },
  {
    value: "Asia/Kathmandu",
    label: "(UTC+05:45) Kathmandu",
    short: "NPT",
    aliases: ["Asia/Katmandu"],
  },
  { value: "Asia/Almaty", label: "(UTC+06:00) Astana", short: "ALMT", aliases: ["Asia/Bishkek"] },
  {
    value: "Asia/Dhaka",
    label: "(UTC+06:00) Dhaka",
    short: "BST",
    aliases: ["Asia/Thimphu", "Asia/Thimbu"],
  },
  { value: "Asia/Omsk", label: "(UTC+06:00) Omsk", short: "OMST" },
  {
    value: "Asia/Yangon",
    label: "(UTC+06:30) Yangon (Rangoon)",
    short: "MMT",
    aliases: ["Asia/Rangoon", "Indian/Cocos"],
  },
  {
    value: "Asia/Bangkok",
    label: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    short: "ICT",
    aliases: [
      "Asia/Hanoi",
      "Asia/Ho_Chi_Minh",
      "Asia/Saigon",
      "Asia/Jakarta",
      "Asia/Phnom_Penh",
      "Asia/Pontianak",
      "Asia/Vientiane",
      "Indian/Christmas",
    ],
  },
  { value: "Asia/Barnaul", label: "(UTC+07:00) Barnaul, Gorno-Altaysk", short: "KRAT" },
  { value: "Asia/Hovd", label: "(UTC+07:00) Hovd", short: "HOVT" },
  { value: "Asia/Krasnoyarsk", label: "(UTC+07:00) Krasnoyarsk", short: "KRAT" },
  { value: "Asia/Novosibirsk", label: "(UTC+07:00) Novosibirsk", short: "NOVT" },
  { value: "Asia/Tomsk", label: "(UTC+07:00) Tomsk", short: "KRAT" },
  {
    value: "Asia/Shanghai",
    label: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    short: "CST",
    aliases: ["Asia/Hong_Kong", "Asia/Urumqi", "Asia/Macau", "Asia/Macao"],
  },
  { value: "Asia/Irkutsk", label: "(UTC+08:00) Irkutsk", short: "IRKT" },
  {
    value: "Asia/Singapore",
    label: "(UTC+08:00) Kuala Lumpur, Singapore",
    short: "SGT",
    aliases: ["Asia/Kuala_Lumpur", "Asia/Brunei", "Asia/Makassar", "Asia/Manila"],
  },
  { value: "Australia/Perth", label: "(UTC+08:00) Perth", short: "AWST" },
  { value: "Asia/Taipei", label: "(UTC+08:00) Taipei", short: "CST" },
  {
    value: "Asia/Ulaanbaatar",
    label: "(UTC+08:00) Ulaanbaatar",
    short: "ULAT",
    aliases: ["Asia/Choibalsan"],
  },
  { value: "Australia/Eucla", label: "(UTC+08:45) Eucla", short: "ACWST" },
  { value: "Asia/Chita", label: "(UTC+09:00) Chita", short: "YAKT" },
  {
    value: "Asia/Tokyo",
    label: "(UTC+09:00) Osaka, Sapporo, Tokyo",
    short: "JST",
    aliases: ["Pacific/Palau", "Asia/Dili", "Asia/Jayapura"],
  },
  { value: "Asia/Pyongyang", label: "(UTC+09:00) Pyongyang", short: "KST" },
  { value: "Asia/Seoul", label: "(UTC+09:00) Seoul", short: "KST" },
  {
    value: "Asia/Yakutsk",
    label: "(UTC+09:00) Yakutsk",
    short: "YAKT",
    aliases: ["Asia/Khandyga"],
  },
  {
    value: "Australia/Adelaide",
    label: "(UTC+09:30) Adelaide",
    short: "ACDT",
    aliases: ["Australia/Broken_Hill"],
  },
  { value: "Australia/Darwin", label: "(UTC+09:30) Darwin", short: "ACST" },
  {
    value: "Australia/Brisbane",
    label: "(UTC+10:00) Brisbane",
    short: "AEST",
    aliases: ["Australia/Lindeman"],
  },
  {
    value: "Australia/Sydney",
    label: "(UTC+10:00) Canberra, Melbourne, Sydney",
    short: "AEDT",
    aliases: ["Australia/Canberra", "Australia/Melbourne", "Australia/Currie"],
  },
  {
    value: "Pacific/Port_Moresby",
    label: "(UTC+10:00) Guam, Port Moresby",
    short: "PGT",
    aliases: ["Pacific/Guam", "Pacific/Saipan", "Pacific/Truk", "Pacific/Chuuk", "Pacific/Yap"],
  },
  {
    value: "Australia/Hobart",
    label: "(UTC+10:00) Hobart",
    short: "AEDT",
    aliases: ["Antarctica/Macquarie"],
  },
  {
    value: "Asia/Vladivostok",
    label: "(UTC+10:00) Vladivostok",
    short: "VLAT",
    aliases: ["Asia/Ust-Nera"],
  },
  { value: "Australia/Lord_Howe", label: "(UTC+10:30) Lord Howe Island", short: "LHDT" },
  { value: "Pacific/Bougainville", label: "(UTC+11:00) Bougainville Island", short: "BST" },
  { value: "Asia/Srednekolymsk", label: "(UTC+11:00) Chokurdakh", short: "SRET" },
  { value: "Asia/Magadan", label: "(UTC+11:00) Magadan", short: "MAGT" },
  { value: "Pacific/Norfolk", label: "(UTC+11:00) Norfolk Island", short: "NFT" },
  { value: "Asia/Sakhalin", label: "(UTC+11:00) Sakhalin", short: "SAKT" },
  {
    value: "Pacific/Guadalcanal",
    label: "(UTC+11:00) Solomon Is., New Caledonia",
    short: "SBT",
    aliases: [
      "Pacific/Noumea",
      "Pacific/Efate",
      "Pacific/Kosrae",
      "Pacific/Pohnpei",
      "Pacific/Ponape",
    ],
  },
  {
    value: "Asia/Kamchatka",
    label: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    short: "PETT",
    aliases: ["Asia/Anadyr"],
  },
  {
    value: "Pacific/Auckland",
    label: "(UTC+12:00) Auckland, Wellington",
    short: "NZDT",
    aliases: ["Antarctica/McMurdo", "Antarctica/South_Pole"],
  },
  {
    value: "Etc/GMT-12",
    label: "(UTC+12:00) Coordinated Universal Time+12",
    short: "GMT+12",
    aliases: [
      "Pacific/Funafuti",
      "Pacific/Kwajalein",
      "Pacific/Majuro",
      "Pacific/Nauru",
      "Pacific/Tarawa",
      "Pacific/Wake",
      "Pacific/Wallis",
    ],
  },
  { value: "Pacific/Fiji", label: "(UTC+12:00) Fiji", short: "FJT" },
  { value: "Pacific/Chatham", label: "(UTC+12:45) Chatham Islands", short: "CHADT" },
  {
    value: "Pacific/Tongatapu",
    label: "(UTC+13:00) Nuku'alofa",
    short: "TOT",
    aliases: ["Pacific/Enderbury", "Pacific/Kanton", "Pacific/Fakaofo"],
  },
  { value: "Pacific/Apia", label: "(UTC+13:00) Samoa", short: "WST" },
  { value: "Pacific/Kiritimati", label: "(UTC+14:00) Kiritimati Island", short: "LINT" },
];

const ALIAS_TO_PRIMARY: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const tz of TIMEZONE_OPTIONS) {
    if (tz.aliases) {
      for (const alias of tz.aliases) {
        map[alias] = tz.value;
      }
    }
  }
  return map;
})();

export function resolvePrimaryTimezone(ianaId: string): string {
  if (TIMEZONE_OPTIONS.some((t) => t.value === ianaId)) return ianaId;
  return ALIAS_TO_PRIMARY[ianaId] ?? ianaId;
}

export function resolveDefaultTimezone(): string {
  const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!browserTz) return "America/New_York";
  const resolved = resolvePrimaryTimezone(browserTz);
  if (TIMEZONE_OPTIONS.some((t) => t.value === resolved)) return resolved;
  return "America/New_York";
}

export function findTimezoneOption(ianaId: string): TimezoneOption | undefined {
  const primary = resolvePrimaryTimezone(ianaId);
  return TIMEZONE_OPTIONS.find((t) => t.value === primary);
}
